import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialog } from "@angular/material";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ClienteModel } from "app/model/cliente/cliente.model";
import { ClienteService } from "app/service/cliente/cliente.service";
import { ParamsService } from "app/service/cliente/params/params.service";
import { EventEmitterService } from "app/service/event-emitter-service";

import { ParamGroupDialogComponent } from "../dialog/param-group-dialog/param-group-dialog.component";
import { ParamTypeDialogComponent } from "../dialog/param-type-dialog/param-type-dialog.component";

@Component({
  selector: "app-config-params",
  templateUrl: "./config-params.component.html",
  styleUrls: ["./config-params.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ConfigParamsComponent implements OnInit {
  paramsGroup: any[] = [];
  isLoading = true;
  groupSelected: {
    clientId: number;
    description: string;
    id: number;
    name: string;
  };
  companyIdSelected = 0;
  paramSelected: any;
  params: any[] = [];
  companies: ClienteModel[] = [];

  $isNewParamGroupSaved = false;
  $isNewParamSaved = false;
  filteredCompanies: ClienteModel[] = [...this.companies];

  constructor(
    public _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private paramService: ParamsService,
    private clienteService: ClienteService
  ) {
    EventEmitterService.get("isNewParamGroupSaved").subscribe((d: boolean) => {
      this.$isNewParamGroupSaved = d;
      this.getAllParamsGroup();
    });
    EventEmitterService.get("isNewParamSaved").subscribe((groupId: number) => {
      if (this.groupSelected && this.groupSelected.id === groupId) {
        this.getAllParamsByGroup();
      }
    });
  }

  ngOnInit() {
    // this.getPermissionCliente(this.clientId);
    this.getAllParamsGroup();
    this.getAllCompanies();
  }

  getAllParamsGroup() {
    this.isLoading = true;
    this.paramService.getAllParamsGroups().subscribe(
      (data) => {
        this.isLoading = false;
        this.paramsGroup = data;
        this.groupSelected = null;
        if (data.length === 0) {
          return this.openSnackBar("Não há grupos de parâmetros Salvos", true);
        }

        this.groupSelected = data[1];

        return this.getAllParamsByGroup();
      },
      (err) => {
        this.openSnackBar(
          "Ocorreu um erro ao buscar os grupos de parâmetros",
          true
        );
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onSearch(EvTarget: any) {
    // console.log("sa",this.GROUPSs)
    const value = EvTarget.value;
    const filter = value.toLowerCase();

    this.filteredCompanies = this.companies.filter((comp) =>
      comp.nomeFantasia
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .startsWith(filter)
    );
  }

  // getPermissionCliente(idCliente: number) {
  //     this.permissoesService.getPermissionEmpresa(idCliente).subscribe(data => {
  //     const arrayAuthorityCliente: any[] = [];
  //     data.forEach(el => {
  //       arrayAuthorityCliente.push(el.authority);
  //     });
  //     this.permissoesService.setItemAuthority('authority-Empresa', arrayAuthorityCliente);
  //     this.getAuthority();
  //   }, err => {
  //     console.error(err);
  //     this.openSnackBar('Ocorreu um erro, tente novamente mais tarde', true);
  //   });
  // }

  // getAuthority() {
  //   this.arrayString = this.permissoesService.getItemAuthority('authority-Empresa');
  //   if (this.arrayString.includes('EDIT_PARAMS')) {
  //     this.paramEditor = true;
  //   }
  //   if (this.arrayString.includes('SUPER_USER')) {
  //     this.superUser = true;
  //   }
  // }

  onGroupSelectionChange() {
    this.getAllParamsByGroup();
  }

  // onCompanySelectionChange() {
  //   return this.getAllParamsByGroup();
  // }

  getAllCompanies() {
    this.clienteService
      .getClientesAll()
      .toPromise()
      .then((d) => {
        this.companies = d;
        this.filteredCompanies = [...this.companies];
      })
      .catch((err) => console.error(err));
  }

  getAllParamsByGroup() {
    this.isLoading = true;
    this.paramService.getParamsByGroup(this.groupSelected.id).subscribe(
      (data) => {
        this.isLoading = false;
        if (data.length === 0) {
          this.openSnackBar("Este Grupo não possui parâmetros salvos", true);
        }
        this.paramSelected = null;
        this.params = data;
      },
      (err) => {
        this.openSnackBar("Ocorreu um erro ao buscar os parâmetros", true);
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  // getAllParamsByGroup() {
  //   if (!this.groupSelected) {
  //     return this.openSnackBar("Selecione um grupo de parâmetros", true);
  //   }

  //   this.isLoading = true;
  //   this.paramService
  //     .getParamsByGroupAndCompany(this.groupSelected.id, this.companyIdSelected)
  //     .subscribe(
  //       (data) => {
  //         this.isLoading = false;
  //         if (data.length === 0) {
  //           this.openSnackBar(
  //             "Esta Empresa não possui parâmetros salvos",
  //             true
  //           );
  //         }
  //         this.paramSelected = null;
  //         this.params = data;
  //       },
  //       (err) => {
  //         this.openSnackBar("Ocorreu um erro ao buscar os parâmetros", true);
  //         console.error(err);
  //         this.isLoading = false;
  //       }
  //     );
  // }

  openDialogGroup(isEditGroup: boolean) {
    const dialogRef = this.dialog.open(ParamGroupDialogComponent, {
      width: "500px",
      data: {
        // clientId: this.clientId,
        isEditGroup,
        groupToEdit: this.groupSelected,
      },
    });
  }

  openDialogParamType(
    isEditParam: boolean,
    mode: "PARAM_EDIT" | "PARAM_COMPANY_EDIT"
  ) {
    const companySel = this.companies.find(
      (el) => el.id === this.companyIdSelected
    );

    const dialogRef = this.dialog.open(ParamTypeDialogComponent, {
      //param Dialog
      width: "500px",
      data: {
        groupSelected: this.groupSelected,
        isEditParam,
        paramToEdit: this.paramSelected,
        companyIdSelected: this.companyIdSelected,
        companyName: companySel ? companySel.nomeFantasia : null,
        mode,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "PARAM_SAVED") {
        this.getAllParamsByGroup();
      }
    });
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/config-params/config-params.component.ts